import { Component, Input, OnInit } from '@angular/core';
import {
  ContactUsData,
  defaultCareerData,
  defaultContactUsData,
} from 'src/app/shared/models/registration';
import { NotificationService } from 'src/app/shared/services/notification.service';
import { RegistrationService } from 'src/app/shared/services/user/registration.service';

@Component({
  selector: 'app-static-form',
  templateUrl: './static-form.component.html',
  styleUrls: ['./static-form.component.scss'],
})
export class StaticFormComponent implements OnInit {
  @Input() formType;

  careerApplicationData: ContactUsData = JSON.parse(
    JSON.stringify(defaultCareerData),
  );
  generalFormData: ContactUsData = JSON.parse(
    JSON.stringify(defaultContactUsData),
  );

  fileToUpload: any;
  formData: any;
  submitedForm: boolean = false;

  constructor(
    private notificationService: NotificationService,
    private registrationService: RegistrationService,
  ) {}

  ngOnInit() {}

  handleFileInput(e) {
    this.fileToUpload = e.target.files.item(0);
  }

  populateGeneralModel(formData) {
    this.formData = formData.form.controls;

    this.generalFormData.name =
      this.formData.firstName.value + ' ' + this.formData.lastName.value;
    this.generalFormData.email = this.formData.email.value;
    this.generalFormData.phone = this.formData.phone.value;

    this.generalFormData.message = this.formData.message.value;
    this.generalFormData.contact_method = this.formData.contactMethod?.value;
    this.generalFormData.contact_time = this.formData.contactTime?.value;

    let fd = new FormData();
    fd.append('params', JSON.stringify(this.generalFormData));
    if (this.fileToUpload) {
      fd.append('docs', this.fileToUpload, this.fileToUpload.name);
    }

    return fd;
  }

  onSubmit(e, formData) {
    e.preventDefault();
    if (formData.form.touched !== true) {
      return;
    }

    const fd = this.populateGeneralModel(formData);

    this.registrationService.preRegistration(fd).subscribe(
      () => {
        this.generalFormData = JSON.parse(JSON.stringify(defaultCareerData));
        this.notificationService.showNotify(
          'Your message was sent!',
          'success',
          5000,
        );
        this.submitedForm = true;
      },
      () =>
        this.notificationService.showNotify(
          'Error sending message',
          'error',
          3000,
        ),
    );
  }
}
